import { ApolloClient, HttpLink } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';
import fetch from 'node-fetch';

import { getPossibleTypesFromFragmentTypes } from '../getPossibleTypesFromFragmentTypes';
import fragmentTypes from './fragmentTypes.json';

const link = new HttpLink({
  uri: process.env.REACT_APP_API_PLAYER_ENDPOINT,
  fetch,
});

const cache = new InMemoryCache({
  possibleTypes: getPossibleTypesFromFragmentTypes(fragmentTypes),
});

export const apolloClient = new ApolloClient({
  link,
  cache,
});
